export const inflectNumberCount: Record<number, string> = {
	1: "první",
	2: "druhé",
	3: "třetí",
	4: "čtvrté",
	5: "páté",
	6: "šesté",
	7: "sedmé",
	8: "osmé",
	9: "deváté",
	10: "desáté",
};

export const inflectNumberCountAccusative: Record<number, string> = {
	1: "první",
	2: "druhou",
	3: "třetí",
	4: "čtvrtou",
	5: "pátou",
	6: "šestou",
	7: "sedmou",
	8: "osmou",
	9: "devátou",
	10: "desátou",
};
